<header class="flex flex-col lg:flex-row lg:justify-between lg:items-end gap-4 pt-4 pb-8">
  <div class="flex flex-col justify-between h-12">
    <h1 class="text-xl font-bold text-color">{{ title }}</h1>
    <p class="text-lg subtext-color">{{ subtitle }}</p>
  </div>

  <ng-content></ng-content>
</header>
